module.exports = __webpack_public_path__ + "media/images/logo_black-df5f10a4a5b4f019c7b88fb630286038.png";